import documentText from "./document-text";

export default function (text, language) {
  try {
    return documentText[text][language];
  }
  catch (e) {
    throw Error(`can't find ${text}`);
  }
};